module.exports = __webpack_public_path__ + "static/media/HH2.53466d24.png";